import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { toast } from "react-toastify";
import Loader from "../Loader";
import BtnLoader from "../BtnLoader";
import { useTranslation } from "react-i18next";

function AssetImportPopup({ setPopup, authCtx, setConfig, config }) {
  const { t } = useTranslation();
  // const [assetData, setAssetData] = useState([]);
  const [teams, setTeams] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState();
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState();
  // const [assetType, setAssetType] = useState();
  const [assetTypeData, setAssetTypeData] = useState({
    properties: [],
    parameters: [],
  });
  const [noTeamWarning, setNoTeamWarning] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  const onCloseClick = (e) => {
    setPopup();
  };

  const onTeamChange = async (assetType, selectedFields) => {
    setDataLoader(true);
    let res = await axios.get(`${BASE_URL}/AssetType/${assetType.id}`);
    const resData = {
      ...res.data,
      properties: res.data.properties.map((a) =>
        selectedFields.some((obj) => a.id === obj.fieldId)
          ? { ...a, selected: true, fieldType: "property", fieldId: a.id }
          : { ...a, selected: false, fieldType: "property", fieldId: a.id }
      ),
      parameters: res.data.parameters.map((obj) =>
        selectedFields.some((obj2) => obj.id === obj2.fieldId)
          ? { ...obj, selected: true, fieldType: "parameter", fieldId: obj.id }
          : { ...obj, selected: false, fieldType: "parameter", fieldId: obj.id }
      ),
    };
    setAssetTypeData(resData);
    setDataLoader(false);
    return resData;
  };

  const handlePropertiesClick = (property) => {
    const selectedAssetType = assetTypes.find((x) => x.id === selectedAssetTypeId);
    if (property.selected)
      setAssetTypeData((pre) => ({
        ...pre,
        properties: pre.properties.map((p) =>
          p.id === property.id ? { ...p, selected: false } : p
        ),
      }));
    else if (selectedAssetType.selectedFields.length < 6) {
      setAssetTypeData((pre) => ({
        ...pre,
        properties: pre.properties.map((p) =>
          p.id === property.id ? { ...p, selected: true } : p
        ),
      }));
    }
    if (property.selected === true) {
      // setTeams((pre) =>
      //   pre.map((x) =>
      //     x.id === selectedTeam
      //       ? {
      //           ...x,
      //           selectedFields: [
      //             ...x.selectedFields.filter((obj) => obj.id !== property.id),
      //           ],
      //         }
      //       : x
      //   )
      // );
      setAssetTypes((pre) =>
        pre.map((x) =>
          x.id === selectedAssetTypeId
            ? {
                ...x,
                selectedFields: [
                  ...x.selectedFields.filter((obj) => obj.id !== property.id),
                ],
              }
            : x
        )
      );
    } else {
      if (selectedAssetType.selectedFields.length < 6) {
        // setTeams((pre) =>
        //   pre.map((x) =>
        //     x.id === selectedTeam
        //       ? {
        //           ...x,
        //           selectedFields: [
        //             ...x.selectedFields.filter((obj) => obj.id !== property.id),
        //             property,
        //           ],
        //         }
        //       : x
        //   )
        // );
        setAssetTypes((pre) =>
          pre.map((x) =>
            x.id === selectedAssetTypeId
              ? {
                  ...x,
                  selectedFields: [
                    ...x.selectedFields.filter((obj) => obj.id !== property.id),
                    property,
                  ],
                }
              : x
          )
        );
      }
    }
  };
console.log(assetTypes)
  const handleParameterClick = (parameter) => {
    const selectedAssetType = assetTypes.find((x) => x.id === selectedAssetTypeId);
    if (parameter.selected)
      setAssetTypeData((pre) => ({
        ...pre,
        parameters: pre.parameters.map((p) =>
          p.id === parameter.id ? { ...p, selected: false } : p
        ),
      }));
    else if (selectedAssetType.selectedFields.length < 6) {
      setAssetTypeData((pre) => ({
        ...pre,
        parameters: pre.parameters.map((p) =>
          p.id === parameter.id ? { ...p, selected: true } : p
        ),
      }));
    }
    console.log(parameter)
    if (parameter.selected) {
      // setTeams((pre) =>
      //   pre.map((x) =>
      //     x.id === selectedTeam
      //       ? {
      //           ...x,
      //           selectedFields: [
      //             ...x.selectedFields.filter((obj) => obj.id !== parameter.id),
      //           ],
      //         }
      //       : x
      //   )
      // );
      setAssetTypes((pre) =>
        pre.map((x) =>
          x.id === selectedAssetTypeId
            ? {
                ...x,
                selectedFields: [
                  ...x.selectedFields.filter((obj) => obj.id !== parameter.id),
                ],
              }
            : x
        )
      );
    } else {
      if (selectedAssetType.selectedFields.length < 6) {
        // setTeams((pre) =>
        //   pre.map((x) =>
        //     x.id === selectedTeam
        //       ? {
        //           ...x,
        //           selectedFields: [
        //             ...x.selectedFields.filter(
        //               (obj) => obj.id !== parameter.id
        //             ),
        //             parameter,
        //           ],
        //         }
        //       : x
        //   )
        // );
        setAssetTypes((pre) =>
          pre.map((x) =>
            x.id === selectedAssetTypeId
              ? {
                  ...x,
                  selectedFields: [
                    ...x.selectedFields.filter(
                      (obj) => obj.id !== parameter.id
                    ),
                    parameter,
                  ],
                }
              : x
          )
        );
      }
    }
  };

  const loadTeams = async () => {
    setDataLoader(true);
    const teamIds = authCtx.profile.teamsIds
      ? authCtx.profile.teamsIds.split(",")
      : [];
    const companyId = authCtx.profile.companyId;
    let res = await axios.post(
      `${BASE_URL}/api/TeamMaster/GetByIds?companyId=${companyId}`,
      teamIds
    );
    if (res.status === 200 && res.data.length !== 0) {
      // const finalData = res.data.map((x, i) => {
      //   const teamConfig =
      //     config?.homeConfiguration?.length !== 0 &&
      //     Array.isArray(config?.homeConfiguration)
      //       ? config?.homeConfiguration?.find((y) => y.assetType.id === x.id)
      //       : null;

      //   return {
      //     ...x,
      //     orderIndex: teamConfig?.orderIndex,
      //     selected: i === 0 ? true : false,
      //     selectedFields:
      //       teamConfig?.fields?.map((z) => ({ ...z, id: z.fieldId })) || [],
      //     scheduled: teamConfig?.fields?.length > 0,
      //   };
      // });
      // setTeams(finalData);
      const uniqueAssetTypes = {};

      res.data.forEach(({ assetTypes }) => {
        assetTypes.forEach(({ id, name, assetIds }) => {
          const ids = assetIds?.split(",");

          if (!uniqueAssetTypes[id]) {
            uniqueAssetTypes[id] = { id, name, assetIds: new Set(ids) };
          } else {
            ids?.forEach((aid) => uniqueAssetTypes[id].assetIds.add(aid));
          }
        });
      });

      const result = Object.values(uniqueAssetTypes).map(
        ({ id, name, assetIds }) => ({
          id,
          name,
          assetIds: Array.from(assetIds),
        })
      );
      const finalData = result.map((x, i) => {
        const assetConfig =
          config?.homeConfiguration?.length !== 0 &&
          Array.isArray(config?.homeConfiguration)
            ? config?.homeConfiguration?.find((y) => y.assetType.id === x.id)
            : null;
        return {
          ...x,

          orderIndex: assetConfig?.orderIndex,
          selected: i === 0 ? true : false,
          selectedFields:
            assetConfig?.fields?.map((z) => ({ ...z, id: z.fieldId })) || [],
          scheduled: assetConfig?.fields?.length > 0,
        };
      });
      setAssetTypes(finalData);
      const firstAssetTypeId = res.data[0].assetTypes[0].id;
      const assetType = finalData.find((x) => x.id === firstAssetTypeId);
      setSelectedTeam(res.data[0].id);
      setSelectedAssetTypeId(firstAssetTypeId);
      await onTeamChange(result[0], assetType?.selectedFields || []);
    } else {
      setNoTeamWarning(true);
    }
    setLoading(false);
  };
  // const loadData = async () => {
  //   let res = await axios.get(`${BASE_URL}/Lookup/GetAllAssetTypes`);
  //   setAssetData(res.data);
  // };

  const onImport = async () => {
    setLoading(true);
    const value = {
      ...config,
      userId: authCtx.profile.id,
      homeConfiguration: assetTypes.map((x, index) => ({
        teamId: "",
        teamName: "",
        orderIndex: x?.orderIndex || index,
        assetType: { id: x.id, name: x.name },
        fields: x.selectedFields.map((s) => ({
          fieldId: s.fieldId,
          fieldType: s.fieldType,
          orderIndex: s.orderIndex,
        })),
      })),
    };

    try {
      let payload = value;
      if (authCtx.profile.role === 100)
        payload = { ...value, companyId: authCtx.profile.companyId };
      const res = await axios.post(
        `${BASE_URL}/api/UserConfiguration`,
        payload
      );
      if (res.status === 200) {
        setPopup();
        setConfig(value);
        document.location.reload();
      } else toast.error("An error occured");
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      else toast.error("An error occured");
    }
    setLoading(false);
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };

  // Function to handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Function to handle drop
  const handleDropParam = (e, index) => {
    // setTeams((pre) =>
    //   pre.map((x) => {
    //     if (x.id === selectedTeam) {
    //       const draggedItemIndex = parseInt(
    //         e.dataTransfer.getData("text/plain")
    //       );
    //       const updatedItems = [
    //         ...x.selectedFields.sort((a, b) => a.orderIndex - b.orderIndex),
    //       ];
    //       const draggedItem = updatedItems[draggedItemIndex];
    //       updatedItems.splice(draggedItemIndex, 1);
    //       updatedItems.splice(index, 0, draggedItem);
    //       return {
    //         ...x,
    //         selectedFields: x.selectedFields.map((item, i) => ({
    //           ...item,
    //           orderIndex: updatedItems.findIndex((el) => el.id === item.id),
    //         })),
    //       };
    //     } else return x;
    //   })
    // );

    setAssetTypes((pre) =>
      pre.map((x) => {
        if (x.id === selectedAssetTypeId) {
          const draggedItemIndex = parseInt(
            e.dataTransfer.getData("text/plain")
          );
          const updatedItems = [
            ...x.selectedFields.sort((a, b) => a.orderIndex - b.orderIndex),
          ];
          const draggedItem = updatedItems[draggedItemIndex];
          updatedItems.splice(draggedItemIndex, 1);
          updatedItems.splice(index, 0, draggedItem);
          return {
            ...x,
            selectedFields: x.selectedFields.map((item, i) => ({
              ...item,
              orderIndex: updatedItems.findIndex((el) => el.id === item.id),
            })),
          };
        } else return x;
      })
    );
  };

  const handleDropTeam = (e, index) => {
    // setTeams((pre) => {
    //   // Get the dragged item index
    //   const draggedItemIndex = parseInt(e.dataTransfer.getData("text/plain"));

    //   // Create a sorted copy of the current state
    //   const updatedItems = [...pre].sort((a, b) => a.orderIndex - b.orderIndex);

    //   // Get the dragged item
    //   const [draggedItem] = updatedItems.splice(draggedItemIndex, 1);

    //   // Insert the dragged item at the new index
    //   updatedItems.splice(index, 0, draggedItem);

    //   // Update the orderIndex for each item
    //   return updatedItems.map((item, idx) => ({
    //     ...item,
    //     orderIndex: idx,
    //   }));
    // });

    setAssetTypes((pre) => {
      // Get the dragged item index
      const draggedItemIndex = parseInt(e.dataTransfer.getData("text/plain"));

      // Create a sorted copy of the current state
      const updatedItems = [...pre].sort((a, b) => a.orderIndex - b.orderIndex);

      // Get the dragged item
      const [draggedItem] = updatedItems.splice(draggedItemIndex, 1);

      // Insert the dragged item at the new index
      updatedItems.splice(index, 0, draggedItem);

      // Update the orderIndex for each item
      return updatedItems.map((item, idx) => ({
        ...item,
        orderIndex: idx,
      }));
    });
  };

  const handleTeamChange = (selectedTeam) => {
    // const team = teams.find((x) => x.id === selectedTeam.id);
    const assetType = assetTypes.find((x) => x.id === selectedTeam.id);
    // setSelectedTeam(selectedTeam.id);
    setSelectedAssetTypeId(selectedTeam.id);
    onTeamChange(selectedTeam, assetType.selectedFields);
  };
  // useEffect(() => {
  //   if (config && config.id) {
  //     setDataLoader(true);
  //     const event = {
  //       value: assetData.find(
  //         (a) => a.name === config.homeConfiguration.assetType.name
  //       ),
  //       selectedFields: config.homeConfiguration?.fields,
  //     };
  //     if (event.value !== undefined) {
  //       handleAssetTypeChange(event);
  //     }
  //   }
  // }, [assetData]);

  useEffect(() => {
    loadTeams();
  }, []);

  return (
    <div className=" flex flex-col text-white px-5 pt-5 pb-3 bg-black w-[60vw] h-full rounded-md">
      <div className="h-full flex flex-col">
        <div className="flex justify-between items-start pb-5">
          <div>{t("homeConfigPopup.headerText")}</div>
          <div>
            <button type="button" onClick={onCloseClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="bg-black flex flex-col rounded-md px-1 pb-2 h-fit ">
          <div className=" items-start">{t("homeConfigPopup.teams")}</div>
          <div className="grid grid-cols-4 gap-1 py-2 mt-1 px-3">
            {noTeamWarning && (
              <div className="col-span-4 h-16 text-slate-600 font-medium text-xs flex gap-2 justify-center items-center">
                <img
                  src="information.svg"
                  alt="Information"
                  className="h-4 w-4"
                />
                {t("homeConfigPopup.noTeamsWarningText")}
              </div>
            )}
            {assetTypes
              .sort((a, b) => a.orderIndex - b.orderIndex)
              .map((p, teamIndex) => (
                <button
                  className={`flex gap-3 w-fit text-white rounded-md justify-between h-12 px-2 items-center ${
                    p.id === selectedAssetTypeId
                      ? "bg-blue-500"
                      : "bg-gray-900 hover:bg-cyan-600"
                  }`}
                  draggable
                  onDragStart={(e) => handleDragStart(e, teamIndex)}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDropTeam(e, teamIndex)}
                  onClick={() => handleTeamChange(p)}
                  key={p.id}
                >
                  <div className="flex gap-3 items-center">
                    <div>
                      <img
                        src="team-icon.svg"
                        alt="team"
                        className="h-8 hover:fill-white"
                      />
                    </div>

                    <div className="w-fit text-start">
                      <label className="font-medium text-ellipsis truncate">
                        {p.name}
                      </label>
                      <div className="text-xxs gap-2 flex font-medium justify-between items-center">
                        {/* <label className=" text-xxs text-neutral-300">
                      {t("homeConfigPopup.assetType")}&nbsp;:
                    </label> */}
                        {/* {p.assetType?.name} */}
                        {/* <hr className="border-l border-neutral-100 pl-2 rotate-90" /> */}
                        <label className=" h-fit">
                          {p.assetIds?.length ?? 0}&nbsp;
                          {t("masters.fields.assets")}
                        </label>
                      </div>
                      {/* <div className="text-xxs gap-2 flex items-center font-normal">
                    {p.assetIds?.split(",").length ?? 0}
                    {t("masters.fields.assets")}
                  </div> */}
                    </div>
                    <div className="pr-1 tooltip w-10 self-center">
                      <span
                        className="tooltiptext text-xxs font-normal z-100 ml-11"
                        style={{ marginLeft: "-44px" }}
                      >
                        {p.selectedFields.length === 0
                          ? t("masters.labels.notConfigured")
                          : t("masters.labels.configured")}
                      </span>
                      {p.selectedFields.length === 0 ? (
                        <img
                          src="notScheduleIcon.svg"
                          alt="NotSchedule"
                          className="h-5"
                        />
                      ) : (
                        <img
                          src="scheduleIcon.svg"
                          alt="Schedule"
                          className="h-5"
                        />
                      )}
                    </div>
                  </div>
                </button>
              ))}
          </div>
          {/* <div className="flex gap-8 py-1 text-xs font-medium">
          <div className="flex gap-4 text-gray-100 items-center">
            <label className="w-24">{t("homeConfigPopup.teams")}</label>
            <ComboBox
              data={teams}
              dataItemKey="id"
              textField="name"
              name="name"
              placeholder={t("homeConfigPopup.placeholder")}
              suggest={true}
              clearButton={false}
              className="block placeholder:text-white border-gray-700 rounded-lg bg-[#363945] text-white font-medium px-5  h-9"
              onChange={handleAssetTypeChange}
              value={selectedTeam}
            />
          </div>
          {selectedTeam?.assetTypeId && (
            <div className="flex gap-4 text-gray-100 items-center">
              <label className="w-16 text-neutral-400">
                {t("homeConfigPopup.assetType")}
              </label>
              <div>
                :&nbsp;&nbsp;
                {assetData.find((x) => x.id === selectedTeam.assetTypeId)?.name}
              </div>
            </div>
          )}
        </div> */}
          <div className="bg-neutral-900 rounded-md px-2 mx-2 pb-3 h-3/5 flex flex-col">
            <div className="flex flex-col items-start pt-2">
              {t("homeConfigPopup.availableValues")}
            </div>
            <div className=" overflow-y-auto h-[20vh] mt-2">
              <div className="grid grid-cols-3 gap-3 mb-4 mt-1 px-3">
                {dataLoader && <Loader />}
                {assetTypeData?.properties?.map((p) => (
                  <button
                    type="button"
                    key={p.id}
                    className={`flex justify-center w-full h-9 rounded-lg items-center disabled:opacity-50`}
                    onClick={() => handlePropertiesClick(p)}
                  >
                    <div
                      className={`flex justify-start w-full py-2 px-8 rounded-lg gap-2 items-center ${
                        p.selected
                          ? "bg-blue-500"
                          : "bg-gray-900 hover:bg-cyan-600"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
                        />
                      </svg>
                      <div className="font-light text-xs">{p?.name}</div>
                    </div>
                  </button>
                ))}
                {assetTypeData?.parameters?.map((p) => (
                  <button
                    type="button"
                    key={p.id}
                    className={`flex justify-center w-full rounded-lg h-9 items-center disabled:opacity-50`}
                    onClick={() => handleParameterClick(p)}
                  >
                    <div
                      className={`flex justify-start w-full py-2 gap-2 rounded-lg items-center pl-8 pr-3 ${
                        p.selected
                          ? "bg-blue-500"
                          : "bg-gray-900 hover:bg-cyan-600"
                      }`}
                    >
                      <img
                        src="Sensorlogo.svg"
                        alt="sensorLogo"
                        className="w-6 "
                      />
                      <div className="font-light text-xs flex w-full">
                        <div className="w-3/5 text-start">{p?.name}</div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            <div className="flex flex-col items-start mt-4 mb-2">
              {t("homeConfigPopup.selectedValues")}
            </div>
            <div className="grid grid-cols-3 gap-3 px-3 h-fit min-h-16 mt-1 overflow-y-scroll">
              {assetTypes
                .find((x) => x.id === selectedAssetTypeId)
                ?.selectedFields?.sort((a, b) => a.orderIndex - b.orderIndex)
                .map((p, index) => (
                  <div
                    className="flex justify-start gap-1 bg-blue-500 w-full h-9 py-2 rounded-lg items-center px-8"
                    key={p?.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDropParam(e, index)}
                  >
                    {p?.fieldType === "parameter" ? (
                      <>
                        <img
                          src="Sensorlogo.svg"
                          alt="sensorLogo"
                          className="w-6 "
                        />
                        <div className="font-light text-xs flex w-full">
                          <div className="w-3/5 text-start">
                            {
                              assetTypeData?.parameters?.find(
                                (x) => x.id === p?.fieldId
                              )?.name
                            }
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
                          />
                        </svg>
                        <div className=" font-light text-xs">
                          {
                            assetTypeData?.properties?.find(
                              (x) => x.id === p?.fieldId
                            )?.name
                          }
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="flex bg-black  pb-3 justify-between gap-2 w-full">
          <div className="flex bottom-4 bg-inherit text-xs justify-start items-center mt-3">
            <span className=" text-red-600 mr-2">!</span>
            {t("homeConfigPopup.warningText")}
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              className=" bg-white text-black h-8 rounded-4xl text-center w-24"
              onClick={() => setPopup()}
            >
              {t("button.cancel")}
            </button>
            <button
              type="button"
              className=" bg-indigo-700 flex justify-center items-center text-sm rounded-4xl w-20 h-8 disabled:opacity-40"
              onClick={onImport}
              disabled={loading}
            >
              {loading.formLoading && <BtnLoader />}
              {t("button.save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssetImportPopup;
